import { render, staticRenderFns } from "./PaypalLogo.vue?vue&type=template&id=bae06de8&"
import script from "./PaypalLogo.vue?vue&type=script&lang=js&"
export * from "./PaypalLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports